// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComparativoFranquias_TabelaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/comparativo_franquias/buscaDadosTabela.
 *
 * The model issues `SELECT *` from the per-user view
 * `vw_lista_comparativo_franquias_<userIdSansHyphens>`. The `SELECT *` is not
 * dynamic: the view's columns are fixed by criaViewXcrudComparativo()'s
 * CREATE VIEW statement — a stable franchise axis plus a fixed set of
 * COALESCE'd aggregate columns. Each row is typed by
 * ComparativoFranquias_TabelaRow — which grew the CAC / IAO / conversion /
 * recebimentos / itens-per-orcamento columns in chamado 2026-0025.
 */
import type { ComparativoFranquias_TabelaRow } from './ComparativoFranquias_TabelaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ComparativoFranquias_TabelaResponseDados = ComparativoFranquias_TabelaRow[];

export type ComparativoFranquias_TabelaResponse = ApiResponse<ComparativoFranquias_TabelaResponseDados>;

registerResponseContract('ComparativoFranquias_TabelaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:             { type: 'number',  required: false },
      franquia:                { type: 'string',  required: false },
      numero_orcamentos:       { type: 'number',  required: false },
      valor_orcamentos:        { type: 'number',  required: false },
      entradas:                { type: 'number',  required: false },
      falta_faturar:           { type: 'number',  required: false },
      previsao_faturamento:    { type: 'number',  required: false },
      numero_clientes:         { type: 'number',  required: false },
      ticket_medio:            { type: 'number',  required: false },
      compromissos_total:      { type: 'number',  required: false },
      compromissos_realizados: { type: 'number',  required: false },
      despesas:                { type: 'number',  required: false },
      orcamentos_aprovados:    { type: 'number',  required: false },
      recebimentos:            { type: 'number',  required: false },
      media_itens_orcamento:   { type: 'number',  required: false },
      cac:                     { type: 'number',  required: false },
      conversao_orcamentos:    { type: 'number',  required: false },
      conversao_realizacao:    { type: 'number',  required: false },
      iao:                     { type: 'number',  required: false },
    },
  },
})
